'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _FireFilled = _interopRequireDefault(require('./lib/icons/FireFilled'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _FireFilled;
  exports.default = _default;
  module.exports = _default;